import * as React from 'react'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemText from '@mui/material/ListItemText'
import { ListItemIcon, ListSubheader, Grid } from '@mui/material'
import AirIcon from '@mui/icons-material/Air'
import WaterIcon from '@mui/icons-material/Water'
import schema from '../../schemas/heatpumpsource.json'
import { JSONSchema7 } from 'json-schema'
import { HeatPumpSource } from '../../interfaces/heatpumpsource'
import CreateHeatPump from './CreateHeatPumpSource'
import DeleteHeatPumpSource from './DeleteHeatPumpSource'
import EditHeatPumpSource from './EditHeatPumpSource'

export interface Props {
  disabled: boolean
  data: HeatPumpSource[]
  setData: React.Dispatch<React.SetStateAction<any[]>>
}

export default function HeatPumpSourceList({ disabled, data, setData }: Props) {
  return (
    <List
      dense
      subheader={
        <ListSubheader>
          <Grid container alignItems={'center'}>
            {'Heat Pump Sources'}
            <CreateHeatPump disabled={disabled} data={data} schema={schema as JSONSchema7} setData={setData} />
          </Grid>
        </ListSubheader>
      }
    >
      {data.map((obj: HeatPumpSource, index: number) => {
        return (
          <ListItem
            key={index}
            secondaryAction={
              <>
                <EditHeatPumpSource disabled={disabled} schema={schema as JSONSchema7} value={obj} setData={setData} />
                <DeleteHeatPumpSource disabled={disabled} value={obj} setData={setData} />
              </>
            }
            disablePadding
          >
            <ListItemButton disabled={disabled}>
              <ListItemIcon>{obj.type_ === 'water' ? <WaterIcon /> : <AirIcon />}</ListItemIcon>
              <ListItemText
                primary={obj.name}
                secondary={`type: ${obj.type_}`}
                sx={{ '.MuiListItemText-secondary': { display: { xs: 'none', sm: 'block' } } }}
              />
            </ListItemButton>
          </ListItem>
        )
      })}
    </List>
  )
}
